<span class="auto-save-status small" role="status" aria-live="polite" [ngClass]="'auto-save-status--' + state">
  @switch (state) {
    @case ('saving') {
      <span class="auto-save-status__label text-muted">{{ 'SETTINGS.AUTOSAVE.SAVING' | translate }}</span>
    }
    @case ('saved') {
      <span class="auto-save-status__label text-success"><i class="lnr lnr-checkmark-circle me-1" aria-hidden="true"></i>{{ 'SETTINGS.AUTOSAVE.SAVED' | translate }}</span>
    }
    @case ('error') {
      <span class="auto-save-status__label text-danger">{{ 'SETTINGS.AUTOSAVE.ERROR' | translate }}</span>
    }
  }
</span>
